import { InputWrapper } from './components/InputWrapper'
import { Wrapper } from './components/Wrapper'
import { useLogic } from './hooks/useLogic'

export const Form = {
  Wrapper,
  InputWrapper,

  useLogic,
}

export * from '../onboarding/types'
